import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ROUTING_PATH } from '../../../../app-routing-path.const';
import { TabGroupConfig } from '@components/tab-group/tab-group.component';

@Component({
  selector: 'aux-timeline-group',
  templateUrl: './timeline-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineGroupComponent {
  tabs: TabGroupConfig[] = [
    {
      label: 'Trial Timeline',
      route: ROUTING_PATH.FORECAST_ROUTING.TIMELINE.TRIAL_TIMELINE,
    },
    {
      label: 'Payment Milestones',
      route: ROUTING_PATH.FORECAST_ROUTING.TIMELINE.PAYMENT_MILESTONES,
    },
  ];
}
